import LabelTextGroup from './LabelTextGroup';
import { LabelTextGroupProps, LabelTextGroupValueProps } from './types';

export type { LabelTextGroupProps, LabelTextGroupValueProps };
export default LabelTextGroup;
